/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * PHRMPC.Manning.Web.API | v1
 * OpenAPI spec version: 1.0.0
 */
import { z as zod } from 'zod';
import { ICollectionOfDailyActivityMonitoringLogDetailDto } from './iCollectionOfDailyActivityMonitoringLogDetailDto.schema';
import { TimeOnly } from './timeOnly.schema';

export const DailyActivityMonitoringLogHeaderDto = zod.object({
  "id": zod.string().uuid().optional(),
  "logId": zod.string().optional(),
  "coordinatorId": zod.string().uuid().optional(),
  "coordinatorName": zod.string().optional(),
  "dailyWorkSchedule": zod.string().optional(),
  "date": zod.coerce.date().optional(),
  "time": zod.lazy(() => TimeOnly).optional(),
  "branchId": zod.number().optional(),
  "statusId": zod.number().optional(),
  "statusName": zod.string().optional(),
  "createdBy": zod.string().optional(),
  "dailyActivityMonitoringLogDetails": zod.lazy(() => ICollectionOfDailyActivityMonitoringLogDetailDto).optional()
});

export type DailyActivityMonitoringLogHeaderDto = zod.input<typeof DailyActivityMonitoringLogHeaderDto>;
export type DailyActivityMonitoringLogHeaderDtoOutput = zod.output<typeof DailyActivityMonitoringLogHeaderDto>;
